import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Icon, DA_IconNames } from "../Icon/Icon.component";
import S from "./Chip.module.scss";

export interface DA_ChipProps {
    label: string;
    removable?: boolean;
    onRemove?: () => void;
    className?: string;
}

export const DA_Chip = ({ label, removable, onRemove, className }: DA_ChipProps) => (
    <div className={cn(S.chip, removable && S.removable, className)}>
        <div className={S.label}>{label}</div>
        {removable && (
            <div className={S.remove}>
                <button
                    type="button"
                    onMouseDown={(event) => event.stopPropagation()}
                    onClick={onRemove}
                    className={S.removeButton}
                >
                    <DA_Icon className={S.removeIcon} name={DA_IconNames.Remove} />
                </button>
            </div>
        )}
    </div>
);
